export default __webpack_public_path__ + "static/media/previous_expo_2019 (8).f78936e8.jpg";